import { ArrowLeft, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PlaceholderPageProps {
  section: string;
  title: string;
  description?: string;
  storyRef?: string;
}

export function PlaceholderPage({
  section,
  title,
  description,
  storyRef,
}: PlaceholderPageProps): JSX.Element {
  return (
    <div className="mx-auto max-w-xl py-12">
      <header className="mb-6">
        <span className="text-[11px] font-medium uppercase tracking-wider text-muted-3">
          {section}
        </span>
        <h1 className="mt-2 text-[28px] font-bold leading-tight tracking-[-0.025em] text-ink">
          {title}
        </h1>
      </header>

      <div className="rounded-[14px] border border-line bg-panel p-[18px]">
        <p className="text-[13px] leading-[1.5] text-ink-2">
          {description ?? 'Esta seção entra em breve. O esqueleto está pronto, falta o conteúdo.'}
        </p>

        {storyRef && (
          <p className="mt-3 font-mono text-[11px] text-muted-2">
            Implementação prevista — {storyRef}
          </p>
        )}

        <div className="mt-5 flex items-center gap-3 border-t border-line pt-4 text-[12px]">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-1 text-ink transition-colors hover:text-ink-2"
          >
            <ArrowLeft size={13} strokeWidth={2} />
            Dashboard
          </Link>
          <span className="text-muted-3">·</span>
          <a
            href="mailto:opusowl.ltda@gmail.com"
            className="inline-flex items-center gap-1 text-muted transition-colors hover:text-ink"
          >
            <Mail size={13} strokeWidth={2} />
            Avisar o time
          </a>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-xl py-16 text-center">
      <span className="font-mono text-[11px] uppercase tracking-wider text-muted-3">404</span>
      <h1 className="mt-2 text-[34px] font-bold leading-tight tracking-[-0.025em]">
        Página não encontrada.
      </h1>
      <p className="mt-3 text-[13px] text-muted">
        O endereço que você acessou não existe (ainda). Pode ter sido movido ou nunca esteve aqui.
      </p>
      <Link
        to="/dashboard"
        className="mt-6 inline-flex items-center gap-1 text-[12px] font-medium text-ink transition-colors hover:text-ink-2"
      >
        <ArrowLeft size={13} strokeWidth={2} />
        Voltar pro dashboard
      </Link>
    </div>
  );
}
